module.exports = __webpack_public_path__ + "static/media/achievement-appreciate-a-colleague.556b99d1.svg";